import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { withApollo } from '@apollo/client/react/hoc';
import { ISSUES_GROUP, VCS_FROM_SLUG } from '../constants/api';
import { IS_APP_CODEAC } from '../constants/env';
import Icon from '../components/Icon';
import filterProps from '../utils/filterProps';
import { toolIcon, toolIconByIssueName } from '../constants/toolIcons';
import { HANDLED_ERRORS } from '../constants/types';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import { replaceAsciiCharWithSlash, replaceSlashWithAsciiChar, resolveBranchName } from '../utils/resolveBranch';
import ApiV2ModelContext from '../contexts/ApiV2ModelContext';
import { getActiveBranch } from '../pages/RepositoryPage';
import { urlContainsGroup } from '../pages/CommitPage';
export function resolveFilterGroupType(hiddenType, type) {
    if (!hiddenType || ISSUES_GROUP.ALL === hiddenType) {
        return '';
    }
    const typeToHide = type ?? hiddenType;
    return typeToHide === ISSUES_GROUP.ERRORS ? ISSUES_GROUP.WARNINGS : ISSUES_GROUP.ERRORS;
}
export class MostCommonIssues extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
            commitIssuesData: [],
            loadingMore: false,
            issuesLimit: 10,
            moreIssuesCount: 0,
        };
        this.loadCommonIssuesData = async (newLimit) => {
            const { limit, commitHash, defectList, fetchCommonIssues, hiddenType, location, onlyNew } = this.props;
            const limitForIssues = newLimit ? newLimit : limit;
            if (!fetchCommonIssues) {
                this.setState({
                    loading: false,
                    commitIssuesData: defectList.defects,
                    moreIssuesCount: defectList.totalNodes - limitForIssues,
                    issuesLimit: limitForIssues,
                });
            }
            if (fetchCommonIssues && commitHash) {
                if (limitForIssues) {
                    this.setState((prevState) => ({
                        loadingMore: true,
                        issuesLimit: prevState.issuesLimit > limitForIssues ? prevState.issuesLimit : limitForIssues,
                    }));
                }
                const group = resolveFilterGroupType(hiddenType);
                const isTypeFilterActive = !!(hiddenType && group !== ISSUES_GROUP.ALL && urlContainsGroup(location.pathname));
                const loadQuery = !!newLimit || isTypeFilterActive;
                await this.loadMostCommonIssues(limitForIssues, !onlyNew, loadQuery, isTypeFilterActive ? group : '');
            }
        };
        this.loadMostCommonIssues = async (limitForIssues, showAll, loadQuery, issueType) => {
            const { match, onlyNew, commitHash, defectList } = this.props;
            if (!showAll && onlyNew && !defectList?.defects.length) {
                await this.loadMostCommonIssues(limitForIssues, true, true);
            }
            if (loadQuery) {
                try {
                    const defectListResponse = await this.context.getDefectList(commitHash, VCS_FROM_SLUG[match.params.vcs], limitForIssues, !showAll && onlyNew, issueType);
                    const { defects, totalNodes: defectsTotalNodes } = defectListResponse;
                    this.setState({
                        loading: false,
                        loadingMore: false,
                        commitIssuesData: defects,
                        moreIssuesCount: defectsTotalNodes - limitForIssues,
                    });
                }
                catch (error) {
                    const statusCode = error.networkError?.statusCode;
                    if (HANDLED_ERRORS.includes(statusCode)) {
                        this.setState({
                            loading: false,
                        });
                    }
                    else {
                        throw error;
                    }
                }
            }
            else if (defectList.totalNodes) {
                this.setState({
                    loading: false,
                    loadingMore: false,
                    commitIssuesData: defectList.defects,
                    moreIssuesCount: defectList.totalNodes - limitForIssues,
                });
            }
        };
        this.handleRuleClick = (tool, ruleId) => {
            const { commitHash, history, match, repository, activeBranches } = this.props;
            const identifier = ruleId ? replaceSlashWithAsciiChar(ruleId) : '';
            const mainBranch = repository.getMainBranch();
            let activeBranch = null;
            try {
                activeBranch = getActiveBranch(repository, activeBranches);
                const branchName = `${activeBranch && activeBranch.name !== mainBranch.name ? '/b-' + replaceSlashWithAsciiChar(activeBranch.name) : ''}`;
                history.push(`/${match.params.vcs}/${match.params.owner}/${match.params.repository}${branchName}/commits/${commitHash}/${identifier}`);
            }
            catch (error) {
                console.warn(error);
            }
        };
        this.handleTypeClick = (type, deselect = false) => {
            const { commitHash, history, match, repository, activeBranches, onlyNew } = this.props;
            const { issuesLimit } = this.state;
            const mainBranch = repository.getMainBranch();
            let activeBranch = null;
            let branchName = '';
            try {
                activeBranch = getActiveBranch(repository, activeBranches);
                branchName = resolveBranchName(activeBranch?.name ?? '', mainBranch.name, activeBranch?.main ?? false);
                this.loadMostCommonIssues(issuesLimit, !onlyNew, true, type);
            }
            catch (error) {
                console.warn(error);
            }
            const baseUrl = this.resolveCommitDetailBaseUrl(match, branchName, commitHash);
            if (deselect) {
                history.push(baseUrl);
                return;
            }
            history.push(`${baseUrl}/${type ? replaceSlashWithAsciiChar(type) : ''}`);
        };
        this.filterIssuesByType = () => {
            const { issuesLimit, commitIssuesData } = this.state;
            return commitIssuesData.slice(0, issuesLimit);
        };
        this.renderIssueName = (issue, handleRuleClick) => {
            let iconName = null;
            if (Object.prototype.hasOwnProperty.call(toolIcon, issue?.tool)) {
                iconName = toolIcon[issue.tool];
            }
            else if (Object.prototype.hasOwnProperty.call(toolIconByIssueName, issue.tool)) {
                iconName = toolIconByIssueName[issue.tool](issue.name);
            }
            return (_jsxs("div", { className: clsx('flex-grow-1 text-truncate', handleRuleClick && !issue.commitIssue && 'cursor--pointer'), onClick: () => (handleRuleClick ? handleRuleClick(issue.tool, issue.name) : () => void 0), children: [!iconName ? null : _jsx(Icon, { name: iconName, fixedWidth: true, className: "mr-2", title: issue.tool }), issue.name] }));
        };
        this.renderDiffNumbers = (issue) => {
            const { t } = this.props;
            return (_jsx("div", { className: "text-nowrap", children: !issue.countDiff ? ('') : issue.countDiff > 0 ? (_jsxs("small", { className: "text-danger ml-1 mr-1 float-left", children: ["(+", new Intl.NumberFormat(t('numberFormatLocale')).format(issue.countDiff), ")"] })) : (_jsxs("small", { className: "text-success ml-1 mr-1 float-left", children: ["(", new Intl.NumberFormat(t('numberFormatLocale')).format(issue.countDiff), ")"] })) }));
        };
        this.renderIssueTypeIcons = (issue, group, handleRuleClick) => {
            const { icons, t } = this.props;
            const isError = group === ISSUES_GROUP.ERRORS || issue.isError;
            const countOfIssueProblems = new Intl.NumberFormat(t('numberFormatLocale')).format(issue.count);
            return (_jsx("span", { className: clsx('most-common-issues__rules', handleRuleClick && !issue.commitIssue && 'cursor--pointer'), onClick: () => (handleRuleClick ? handleRuleClick(issue.tool, issue.name) : () => void 0), children: _jsxs("div", { className: clsx('most-common-issues__rules--row', isError ? 'text-danger' : 'text-warning'), children: [_jsx("span", { className: "most-common-issues__rules--row-text", children: countOfIssueProblems }), !icons ? null : _jsx(Icon, { name: `exclamation-${isError ? 'circle' : 'triangle'}`, className: "ml-2" })] }) }));
        };
        this.resolveHighlightedClasses = (issue, handleRuleClick) => {
            const { highlightedRules } = this.props;
            const { name: issueName, ...issueProps } = issue;
            const showHighlightable = handleRuleClick && !issueProps.commitIssue;
            const haveHighlightedRule = highlightedRules && highlightedRules.includes(issueProps.tool + '#' + issueName);
            return clsx('most-common-issues__row', {
                'most-common-issues__row--highlightable': showHighlightable,
                'most-common-issues__row--highlighted': haveHighlightedRule,
            });
        };
        this.renderTableRows = () => {
            const { className, onRuleClick, hiddenType, twoColumns, isCommitProcessing, t } = this.props;
            const { loading } = this.state;
            const group = resolveFilterGroupType(hiddenType);
            const filteredIssues = this.filterIssuesByType();
            const handleRuleClick = onRuleClick || this.handleRuleClick;
            const noIssuesTypeMessage = group === ISSUES_GROUP.ERRORS ? t('noErrorsFound') : t('noWarningsFound');
            const classes = 'most-common-issues__container' +
                (twoColumns && !loading ? ' most-common-issues__container--two-columns' : '') +
                (className ? ' ' + className : '');
            return (_jsx("div", { className: classes, children: !filteredIssues.length ? (_jsx("div", { className: "row most-common-issues__row", children: isCommitProcessing
                        ? _jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, size: "3x", className: "mx-auto" })
                        : _jsx("div", { className: "col", children: group ? noIssuesTypeMessage : t('noIssuesFound') }) })) : (filteredIssues.map((issue) => (_jsxs("div", { className: this.resolveHighlightedClasses(issue, handleRuleClick), children: [this.renderIssueName(issue, handleRuleClick), this.renderDiffNumbers(issue), this.renderIssueTypeIcons(issue, group, handleRuleClick)] }, `${issue.name}-${issue.isError}`)))) }));
        };
        this.renderLoadMoreButton = () => {
            const { limit, t } = this.props;
            const { issuesLimit, loadingMore, moreIssuesCount } = this.state;
            const newIssuesLimit = issuesLimit + limit;
            return moreIssuesCount > 0 ? (_jsx("div", { className: "flex-grow-1 text-right", children: _jsxs("button", { className: "btn btn-link btn-sm", onClick: () => this.loadCommonIssuesData(newIssuesLimit), disabled: loadingMore, children: [!loadingMore ? null : _jsx(Icon, { name: "spinner", className: "mr-2", spin: true }), `${t('loadMoreCommonIssues')} (${moreIssuesCount})`] }) })) : null;
        };
        this.renderClearFilterButton = (group) => {
            const { onTypeClick, onRuleClick, highlightedRules, t } = this.props;
            const handleTypeClick = onTypeClick || this.handleTypeClick;
            const handleRuleClick = onRuleClick || this.handleRuleClick;
            return (_jsx("div", { children: _jsxs("button", { className: "btn btn-link btn-sm", onClick: () => group
                        ? handleTypeClick(group, true)
                        : highlightedRules &&
                            handleRuleClick(highlightedRules[0].split('#')[0], highlightedRules[0].split('#')[1]), children: [_jsx(Icon, { name: "times", className: "mr-2" }), t('clearFilter')] }) }));
        };
        this.renderTableContent = () => {
            const { showMoreBtn, highlightedRules, hiddenType } = filterProps(this.props, [
                'commitHash',
                'commitStatus',
                'errorCount',
                'files',
                'filterByNewIssues',
                'filteredFiles',
                'showEmpty',
                'twoColumns',
                'warningCount',
                'history',
                'i18n',
                'lng',
                'location',
                'match',
                'staticContext',
                'tReady',
            ]);
            const { loading, moreIssuesCount } = this.state;
            const group = resolveFilterGroupType(hiddenType);
            const dataFiltered = this.filterIssuesByType();
            const showLoadMoreButton = !!(dataFiltered.length && showMoreBtn && !loading && moreIssuesCount);
            return (_jsxs(_Fragment, { children: [this.renderTableRows(), _jsxs("div", { className: "d-flex", children: [(highlightedRules?.length !== 0 || group) && this.renderClearFilterButton(group), showLoadMoreButton && this.renderLoadMoreButton()] })] }));
        };
        this.renderGroupTab = (issueType, active, tabUrl) => {
            const { onTypeClick, filterByNewIssues, onlyNew, errorCount, warningCount, t } = this.props;
            const { issuesLimit } = this.state;
            const handleTypeClick = (type, deselect) => {
                if (type === ISSUES_GROUP.ALL) {
                    this.loadMostCommonIssues(issuesLimit, !onlyNew, true);
                }
                return onTypeClick ? onTypeClick(type, deselect) : this.handleTypeClick(type, deselect);
            };
            return (_jsx("li", { className: "nav-item most-common-issues__tab", onClick: () => handleTypeClick && handleTypeClick(issueType), children: _jsx("a", { href: tabUrl, onClick: (event) => event.preventDefault(), className: `nav-link${active}`, id: `${issueType}-tab`, "data-toggle": "tab", role: "tab", "aria-controls": issueType, "aria-selected": "true", children: _jsx("span", { className: clsx('tab-name', {
                            'text-danger': issueType === ISSUES_GROUP.ERRORS,
                            'text-warning': issueType === ISSUES_GROUP.WARNINGS,
                        }), children: issueType && issueType === ISSUES_GROUP.ALL ? (_jsxs(_Fragment, { children: [filterByNewIssues
                                    ? ''
                                    : new Intl.NumberFormat(t('numberFormatLocale')).format(errorCount + warningCount), ' ', t('commitIssues', { count: errorCount + warningCount })] })) : (_jsxs(_Fragment, { children: [_jsx(Icon, { name: `exclamation-${issueType === ISSUES_GROUP.ERRORS ? 'circle' : 'triangle'}`, className: "mr-1" }), filterByNewIssues
                                    ? ''
                                    : new Intl.NumberFormat(t('numberFormatLocale')).format(issueType === ISSUES_GROUP.ERRORS ? errorCount : warningCount), ' ', issueType] })) }) }) }, `${issueType}-tab`));
        };
        this.renderTabs = () => {
            const { commitHash, location, hiddenType } = this.props;
            const group = resolveFilterGroupType(hiddenType);
            return (_jsx("ul", { className: "nav nav-tabs nav-fill", id: "mostCommonIssuesTab", role: "tablist", children: Object.values(ISSUES_GROUP).map((issueType) => {
                    const isActive = (issueType === ISSUES_GROUP.ALL && !group) || group === issueType ? ' active' : '';
                    const tabUrl = `${location.pathname.split(commitHash)[0]}${commitHash}${issueType !== ISSUES_GROUP.ALL ? '/' + issueType : ''}`;
                    return this.renderGroupTab(issueType, isActive, tabUrl);
                }) }));
        };
        this.renderTabContent = () => {
            const baseClasses = [
                'tab-pane',
                'container',
                'fade',
                'show',
                'most-common-issues__tab-content',
                !IS_APP_CODEAC && 'most-common-issues__tab-content--old',
            ];
            return (_jsxs("div", { children: [IS_APP_CODEAC && this.renderTabs(), _jsx("div", { className: "tab-content", id: "mostCommonIssuesTabContent", children: Object.values(ISSUES_GROUP).map((issueType) => (_jsx("div", { className: clsx(baseClasses, issueType === ISSUES_GROUP.ALL && 'active'), id: issueType, role: "tabpanel", "aria-labelledby": `${issueType}-tab`, children: this.renderTableContent() }, `${issueType}-tabpanel`))) })] }));
        };
        this.renderLoadingTabs = () => {
            const { t } = this.props;
            return (_jsx(_Fragment, { children: _jsxs("ul", { className: "nav nav-tabs nav-fill", id: "mostCommonIssuesTab", role: "tablist", children: [_jsx("li", { className: "nav-item most-common-issues__tab", children: _jsx("a", { className: "nav-link active", "data-toggle": "tab", role: "tab", children: _jsxs("span", { className: "tab-name", children: [_jsx(Icon, { name: "spinner", spin: true, fixedWidth: true, size: "1x" }), t('allIssues')] }) }) }), _jsx("li", { className: "nav-item most-common-issues__tab", children: _jsx("a", { className: "nav-link", "data-toggle": "tab", role: "tab", children: _jsxs("span", { className: "tab-name text-danger", children: [_jsx(Icon, { name: "exclamation-circle", className: "mr-1" }), _jsx(Icon, { name: "spinner", spin: true, fixedWidth: true, size: "1x" }), t('errors')] }) }) }), _jsx("li", { className: "nav-item most-common-issues__tab", children: _jsx("a", { className: "nav-link", "data-toggle": "tab", role: "tab", children: _jsxs("span", { className: "tab-name text-warning", children: [_jsx(Icon, { name: "exclamation-triangle", className: "mr-1" }), _jsx(Icon, { name: "spinner", spin: true, fixedWidth: true, size: "1x" }), t('warnings')] }) }) }), _jsx("div", { className: "tab-content common-issue__loader", id: "mostCommonIssuesTabContent", children: _jsx(LoadingPlaceholder, { type: "mostCommonIssue", count: 5 }) })] }) }));
        };
    }
    decideWhetherToLoadCommonIssues(props) {
        const { hiddenType, defectList, limit, highlightedRules, onDashboard } = props;
        const { issuesLimit, commitIssuesData } = this.state;
        const issues = commitIssuesData.length ? commitIssuesData : defectList.defects;
        const isRuleHighlighted = highlightedRules.filter(rule => rule.includes('#')).length > 0;
        const isEnoughIssuesByType = hiddenType && !isRuleHighlighted ? issues.filter(issue => hiddenType === ISSUES_GROUP.ERRORS ? !issue.isError : issue.isError).length >= issuesLimit : true;
        if ((!hiddenType && defectList.defects.length >= issuesLimit) || isEnoughIssuesByType) {
            const newLimit = issuesLimit && !onDashboard ? issuesLimit : limit;
            this.setState((prevState) => ({
                commitIssuesData: prevState.commitIssuesData.length ? prevState.commitIssuesData : defectList.defects,
                issuesLimit: newLimit,
                moreIssuesCount: defectList.totalNodes - newLimit,
            }));
        }
        else {
            this.setState({
                loading: true,
            }, this.loadCommonIssuesData);
        }
    }
    UNSAFE_componentWillReceiveProps(props) {
        this.decideWhetherToLoadCommonIssues(props);
    }
    componentDidMount() {
        this.decideWhetherToLoadCommonIssues(this.props);
    }
    resolveCommitDetailBaseUrl(match, branchName, commitHash) {
        let url = '';
        const { vcs, owner, repository, subrepository } = match.params;
        if (vcs && owner && repository) {
            url = `/${vcs}/${owner}/${repository}`;
        }
        if (subrepository) {
            url = `${url}/${subrepository}`;
        }
        if (branchName) {
            url = `${url}/${branchName}`;
        }
        if (commitHash) {
            url = `${url}/commits/${commitHash}`;
        }
        return replaceAsciiCharWithSlash(url);
    }
    render() {
        const { showEmpty, children, t, filteredFiles, onDashboard } = filterProps(this.props, [
            'commitHash',
            'history',
            'i18n',
            'limit',
            'match',
            'onlyNew',
            'staticContext',
            'tReady',
            'showMoreBtn',
            'highlightedRules',
            'onRuleClick',
            'onTypeClick',
            'location',
            'errorCount',
            'warningCount',
            'filterByNewIssues',
        ]);
        const { commitIssuesData, loading } = this.state;
        return loading && (commitIssuesData.length) ? (_jsxs("div", { children: [children, _jsxs("div", { className: "text-center", children: [IS_APP_CODEAC &&
                            (onDashboard ? (_jsx("div", { className: "common-issue-dashboard__loader", children: _jsx(LoadingPlaceholder, { type: "mostCommonIssueDashboard", count: 6 }) })) : (this.renderLoadingTabs())), !IS_APP_CODEAC && _jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, size: "2x" }), _jsxs("span", { className: "sr-only", children: [t('loading'), "..."] })] })] })) : !commitIssuesData.length && !showEmpty ? null : (_jsxs("div", { children: [children, !filteredFiles ? this.renderTableContent() : this.renderTabContent()] }));
    }
}
MostCommonIssues.contextType = ApiV2ModelContext;
MostCommonIssues.defaultProps = {
    twoColumns: false,
    showEmpty: false,
    showMoreBtn: false,
    onlyNew: false,
    limit: 10,
    highlightedRules: [],
    onRuleClick: void 0,
    className: '',
    hiddenType: '',
    icons: false,
    errorCount: 0,
    warningCount: 0,
    filterByNewIssues: false,
    onDashboard: false,
    fetchCommonIssues: false,
    defectList: { defects: [] },
};
const mapStateToProps = (state) => ({
    repository: state.repository.repository,
    activeBranches: state.activeBranches,
});
export default withRouter(
// @ts-expect-error TS2345: Argument of type is not assignable to parameter of type
connect(mapStateToProps)(withTranslation()(withApollo(MostCommonIssues))));
